import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var PromoSlidesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default PromoSlidesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/PromoSlides/PromoSlidesReduxProps.ts
// module id = 420
// module chunks = 0